module.exports = __webpack_public_path__ + "img/messages.c19d48a1.png";